import { useAppSelector } from '../redux/hooks';
import { useAuthOptional } from '../contexts/AuthContext';
import { useNewMatches } from './useNewMatches';

/**
 * Live count for the persistent "My Jobs" header entry (SEEKER_HUB_PLAN.md P1 item 7): new
 * search-alert matches for signed-in users (the re-engagement signal that draws them back into
 * the hub), saved-jobs count for guests (who have no email alerts to surface). Both numbers
 * already live in state every page hydrates — the singleton Redux store for saved jobs, the
 * existing alerts endpoint for matches — so this adds no new data plumbing beyond reusing them.
 */
export function useMyJobsBadgeCount(): number {
  const auth = useAuthOptional();
  const isAuthenticated = Boolean(auth?.isAuthenticated);
  const savedCount = useAppSelector((s) => s.jobs.savedJobs.length);
  const { status, digest } = useNewMatches(isAuthenticated);

  if (isAuthenticated) {
    return status === 'ok' ? digest?.totalNewJobs ?? 0 : 0;
  }
  return savedCount;
}
